import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const deleteGeneralLedger = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/method/technoerp.services.delete_record?record=${record}&document=General Ledger`
  );
  return data;
});

// export const getGeneralLedger = catchAsync(async () => {
//   const { data } = await axiosInstance.get(
//     '/api/method/technoerp.services.get_gl_entries'
//   );
//   return data;
// });

export const getGeneralLedger = catchAsync(async (filters) => {
  const { data } = await axiosInstance.get(
    `api/method/technoerp.services.get_gl_entries?voucher_no=${filters}`
  );
  return data;
});
